import React, { useState, useEffect } from 'react'
import { Tabs, Icon } from 'antd'
import axios from 'util/Api'
import IotSetting from './setting'
import IotIgnitionSetting from './ignition-setting'

const { TabPane } = Tabs

function IotSettingPage({ match }) {
    const [assetData, setAssetData] = useState(null)
    const asset = match && match.params && match.params.asset

    useEffect(() => {
        if (asset) {
            axios.get(`/asset/${asset}`).then(res => {
                setAssetData(res.data)
            })
        }
    }, [asset])

    return (
        <div style={{ padding: '24px', width: '70%' }}>
            <Tabs defaultActiveKey="ignition" type="card" style={{ backgroundColor: '#fff' }}>
                <TabPane tab={<span><Icon type="thunderbolt" theme="filled" style={{ color: 'orange' }} /> Ignition Setting ({assetData && assetData.assetCode || '-'})</span>} key="ignition">
                    <IotIgnitionSetting match={match} assetData={assetData} />
                </TabPane>
                <TabPane tab={<span><Icon type="pause-circle" theme="filled" style={{ color: 'red' }} /> Idle Setting ({assetData && assetData.assetCode || '-'})</span>} key="idle">
                    <IotSetting match={match} assetData={assetData} />
                </TabPane>

            </Tabs>
        </div>
    )
}

export default IotSettingPage

